import React from "react";

export default function Home(props) {
  props.history.push("/projects");
  return <React.Fragment />;
}
